import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Redirect component for backward compatibility with old Meta Ads AI URLs.
 * Reads the company slug from the #react-root DOM element and navigates
 * to the company-scoped URL.
 */
const MetaAdsAIRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const rootElement = document.getElementById('react-root');
    const companySlug = rootElement?.getAttribute('company-slug');

    if (companySlug) {
      navigate(`/marketing/meta_ads_ai/companies/${companySlug}`, { replace: true });
    }
  }, [navigate]);

  return null;
};

export default MetaAdsAIRedirect;
